import { AdministrationProvider } from '@openx/components-administration/lib/utils/context/AdministrationContext.tsx';
import { CoreProvider } from '@openx/components-core/utils/context/CoreContext.tsx';
import { DealProvider } from '@openx/components-deal/lib/utils/context/DealContext.tsx';
import { DealForecastProvider } from '@openx/components-deal/lib/utils/context/DealForecastContext/DealForecastProvider.tsx';
import { DealPromptDomainsProvider } from '@openx/components-deal-prompt/lib/utils/context/DealPromptDomainsContext.tsx';
import { DirectDealsProvider } from '@openx/components-direct-deals/lib/utils/context/DirectDealsContext.tsx';
import { OrganizationProvider } from '@openx/components-organization/lib/utils/context/OrganizationContext.tsx';
import { ProviderContextProvider } from '@openx/components-provider/lib/utils/context/ProviderContext.tsx';
import { SegmentProvider } from '@openx/components-segment/lib/utils/context/SegmentContext.tsx';
import { PermissionProvider } from '@openx/utils/permission/context/PermissionContext.tsx';
import type { Auth } from 'firebase/auth';
import { Outlet } from 'react-router';
import { AuthProvider } from '../components/AuthContext/AuthContext.tsx';
import { useAuth } from '../components/AuthContext/context.ts';
import { GROWTHBOOK_SALT } from '../config.ts';
import { administrationConfig } from './administration/administrationConfig.ts';
import { coreConfig } from './core/coreConfig.ts';
import { dealPromptConfig } from './deal-prompt/dealPromptConfig.ts';
import { dealConfig } from './deals/dealConfig.ts';
import { directDealsConfig } from './direct-deals/directDealsConfig.ts';
import { organizationConfig } from './organization/organizationConfig.ts';
import { PackageProviderWithAuth } from './package/PackageProviderWithAuth.tsx';
import { permissionConfig } from './permission/permissionConfig.ts';
import { providerConfig } from './provider/providerConfig.ts';
import { segmentConfig } from './segment/segmentConfig.ts';
import { TargetingProviderWithAuth } from './targeting/utils/TargetingProviderWithAuth.tsx';

export interface ConfigProvidersProps {
  children: React.ReactNode;
  auth: Auth;
}

export function ConfigProviders({ children, auth }: ConfigProvidersProps) {
  return (
    <AuthProvider auth={auth}>
      {/* <PermissionProvider permissionConfig={permissionConfig}> */}
      <SessionDrill>
        <CoreProvider coreConfig={coreConfig}>
          <DealForecastProvider>
            <DealProvider dealConfig={dealConfig}>
              <PackageProviderWithAuth>
                <TargetingProviderWithAuth>
                  <SegmentProvider segmentConfig={segmentConfig}>
                    <AdministrationProvider administrationConfig={administrationConfig}>
                      <ProviderContextProvider providerConfig={providerConfig}>
                        <DirectDealsProvider directDealsConfig={directDealsConfig}>
                          <DealPromptDomainsProvider dealPromptDomainsConfig={dealPromptConfig}>
                            <OrganizationProvider organizationConfig={organizationConfig}>
                              {children}
                            </OrganizationProvider>
                          </DealPromptDomainsProvider>
                        </DirectDealsProvider>
                      </ProviderContextProvider>
                    </AdministrationProvider>
                  </SegmentProvider>
                </TargetingProviderWithAuth>
              </PackageProviderWithAuth>
            </DealProvider>
          </DealForecastProvider>
        </CoreProvider>
      </SessionDrill>
      {/* </PermissionProvider> */}
    </AuthProvider>
  );
}

// TODO: UIG-540 Temp Workaround for ACL Platform Share
export const SessionDrill = ({ children }) => {
  const { session } = useAuth();

  const permSession = session?.exchange_session;

  return (
    <PermissionProvider
      permissionConfig={permissionConfig}
      session={permSession}
      appName="oxs"
      userEmail={session?.email}
      growthBookSalt={GROWTHBOOK_SALT}
    >
      {children}
    </PermissionProvider>
  );
};

export const Config = ({ auth }: { auth: Auth }) => {
  return (
    <ConfigProviders auth={auth}>
      <Outlet />
    </ConfigProviders>
  );
};
